<div fxLayoutAlign="{{messageAlign}} center">
  <div fxLayout="column" [ngClass]=" isMyMessage ? 'my-message-box' : 'message-box' ">

    <div fxLayout="row" fxLayoutGap="10" fxLayout.lt-md="column">
      <app-sending-channel-icon fxHide.lt-md [sendingChannel]="message.sendingChannelTypeId"
        [size]="24"></app-sending-channel-icon>
      <kendo-icon *ngIf="message.isPriority" name="exclamation-circle" themeColor="error" class="priority-icon"
        title="{{'claims-center.claimMessages.isPriority' | translate}}"></kendo-icon>
      <strong>{{ message.title }}</strong>
      <div class="message-info">
        - <span [title]="message.createdBy">{{ message.senderInfo}}</span> <strong>({{ message.senderRoleId |
          staticDictionaryCaption:'recipientRole' |async}}) </strong>- {{message.timestamp | date:'yyyy-MM-dd
        HH:mm:ss' }}
      </div>
      <div *ngIf="!isMyMessage && message.sendingChannelTypeId === 1" fxLayout="row" fxLayoutGap="10" fxHide.lt-md>
        <button class="hyper-link small-info" (click)="reply()"> {{'claims-center.claimMessages.respond' | translate}}
        </button>
        <button class="hyper-link small-info" (click)="replyAll()"> {{'claims-center.claimMessages.respondToAll' |
          translate}} </button>
      </div>
    </div>

    <div fxLayout="row wrap" [ngClass]=" isMyMessage ? 'my-message-content' : 'message-content' ">

      <div [innerHtml]="message.contentText | safe:'html'"></div>

    </div>

    <div fxLayout="column">
      <div *ngFor="let recipient of message.recipients">
        <div fxLayout="row">
          <kendo-icon name="user" class="k-badge-icon"></kendo-icon>
          <span class="small-info">{{ recipient.recipientInfo}}</span>
          <span class="small-info" *ngIf="!!message.recipientContact"> - {{ recipient.recipientContact}}</span>
          <span class="small-info"><strong>( {{recipient.recipientRole | staticDictionaryCaption: "recipientRole" |
              async}} )</strong></span>
          <ng-container *ngIf="message.sendingChannelTypeId === 1">
            <kendo-icon *ngIf="!!recipient.readConfirmationSent" [name]="'check-circle'" [themeColor]="'success'"
              title="{{recipient.readConfirmationSent | date:'yyyy-MM-dd HH:mm' }}"></kendo-icon>
            <kendo-icon *ngIf="!recipient.readConfirmationSent && recipient.isReadConfirmationRequired"
              [name]="'close-circle'" [themeColor]="'error'"></kendo-icon>
            <kendo-icon *ngIf="recipient.readDate && !recipient.isReadConfirmationRequired " [name]="'check-circle'"
              [themeColor]="'success'" title="{{recipient.readDate | date:'yyyy-MM-dd HH:mm' }}"></kendo-icon>
            <kendo-icon *ngIf="!recipient.readDate && !recipient.isReadConfirmationRequired " [name]="'close-circle'"
              [themeColor]="'error'"></kendo-icon>

              <div *ngIf="message.sendingChannelTypeId === 1 && selfRecipient?.id === recipient.id && readConfirmationEnabled " 
              fxLayout="row" fxLayoutGap="10">
                 <button class="hyper-link small-info" (click)="confirmReading()"> {{'claims-center.claimMessages.confirmReading' | translate}}  </button>
                </div>

          </ng-container>
        </div>
      </div>
    </div>

    <div fxLayout="column">
      <div *ngFor="let attachment of message.attachments">
        <div fxLayout="row">
          <kendo-icon name="clip" class="k-badge-icon"></kendo-icon>
          <span class="small-info">{{ attachment.name }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="!isMyMessage && message.sendingChannelTypeId === 1" fxLayout="row" fxLayoutGap="10" fxShow.lt-md fxHide>
      <button class="hyper-link small-info" (click)="reply()"> {{'claims-center.claimMessages.respond' | translate}}
      </button>
      <button class="hyper-link small-info" (click)="replyAll()"> {{'claims-center.claimMessages.respondToAll' |
        translate}} </button>
    </div>

  </div>

</div>

<div kendoDialogContainer #composeReplyPortalMessageDialog></div>